import api from 'service/index';
import { SOCKET_AUTH_URL } from 'constants/url';


const socketApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAuthToken: builder.query<{ token : string }, string>({
      query: (token) => ({
        method: 'POST',
        url: SOCKET_AUTH_URL,
        // This call can be Authorized using userToken (self-service flow) or admin token (Admin part on Partteam Kiosk)
        headers: { Authorization: token },
      }),
    }),
  }),
});

export default socketApi;
